module.exports = __webpack_public_path__ + "static/media/x.aecf9c5c.png";